import { api } from "./api";
import { endpoints } from "./endpoints";

export const getEventFiltersApi = async (payload: { teamSchema: string }) => {
  return await api.post(endpoints.getEventFilters, payload);
};

export const getUpcomingEventsProductsApi = async (payload: {
  teamSchema: string;
  eventFilters?: {
    dates: string[];
    opponentNames: string[];
    eventCodes: string[];
  };
}) => {
  return await api.post(endpoints.getUpcomingEvents, {
    eventFilters: {
      dates: [],
      opponentNames: [],
      eventCodes: [],
    },
    ...payload,
  });
};

export const getUpcomingEventsApi = async (payload: {
  teamSchema: string;
  eventFilters: {
    dates: string[];
    opponentNames: string[];
    eventCodes: string[];
  };
}) => {
  return await api.post(endpoints.getUpcomingEvents, payload);
};

export const getPackagesApi = async (payload: { teamSchema: string }) => {
  return await api.post(endpoints.getPackages, payload);
};
